import { useUserAccount } from '../configuration/login/loginSlice';
import { useFeatureToggle } from '../configuration/featureFlags/useFeatureToggle';

export const useGetUpsellingBadgeSeenStorageKey = () => {
    const upsellingBadgeSeenStorageKey = useFeatureToggle('upsellingBadgeSeenStorageKey', 'unreadBadgeSeen');
    const accountId = useUserAccount();
    const suffix = accountId ? `.${accountId}` : '';
    return `${upsellingBadgeSeenStorageKey}${suffix}`;
};
